import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ensureValidEnvironment } from '@/lib/env-config'

// Security: Validate environment before starting the application
// This ensures we fail fast with a clear error message if configuration is missing
try {
  ensureValidEnvironment();
} catch (error) {
  console.error(error);

  // Display user-friendly error message
  const rootElement = document.getElementById("root");
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="
        padding: 2rem;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        max-width: 800px;
        margin: 2rem auto;
      ">
        <h1 style="color: #dc2626; margin-bottom: 1rem;">
          ⚠️ Configuration Error
        </h1>
        <pre style="
          background: #fef2f2;
          padding: 1rem;
          border-radius: 0.5rem;
          overflow: auto;
          border-left: 4px solid #dc2626;
          color: #991b1b;
          font-size: 0.875rem;
          line-height: 1.5;
        ">${error instanceof Error ? error.message.replace(/</g, '&lt;').replace(/>/g, '&gt;') : 'Unknown configuration error'}</pre>
        <p style="color: #6b7280; margin-top: 1rem;">
          Please contact your system administrator or check your environment configuration.
        </p>
        <details style="margin-top: 1rem; color: #6b7280;">
          <summary style="cursor: pointer; font-weight: 500;">
            Troubleshooting Steps
          </summary>
          <ol style="margin-top: 0.5rem; padding-left: 1.5rem; line-height: 1.8;">
            <li>Ensure you have a <code>.env</code> file in the project root</li>
            <li>Copy <code>.env.example.secure</code> to <code>.env</code> if it doesn't exist</li>
            <li>Fill in all required environment variables in <code>.env</code></li>
            <li>Restart the development server (<code>npm run dev</code>)</li>
          </ol>
        </details>
      </div>
    `;
  }

  // Prevent further initialization
  throw error;
}

createRoot(document.getElementById("root")!).render(<App />);
